<div class="cart__items">
  <app-product-row *ngFor="let product of purchase.products" [canRemove]="showRemove" [product]="product" (remove)="onRemove($event)"></app-product-row>
</div>
<div class="cart-totals">
	<div *ngIf="purchase.subtotal != purchase.total" class="cart-totals-line">
		Subtotal: <span class="cart-totals-line__value">${{ (purchase.subtotal || 0) | number: '1.2-2'}}</span>
	</div>
  <div *ngIf="purchase.taxAmount" class="cart-totals-line">
    Sales Tax: <span class="cart-totals-line__value">${{ (purchase.taxAmount || 0) | number: '1.2-2'}}</span>
  </div>
	<div class="cart__totals-line cart-totals-line--total">
		Total: <span class="cart-totals-line__value">${{ (purchase.total || 0) | number: '1.2-2'}}</span>
	</div>
</div>
<div *ngIf="showConfirmation" class="cart__actions">
  <button class="button button--tertiary " (click)="onPrint()">
    <i class="button__icon icon icon--print"></i>
    <span class="button__text">Print Receipt</span>
  </button>
</div>
